<template>
	<div class="pointer-events-none absolute top-0 left-0 h-0 w-0 opacity-0">
		<div
			ref="renderContext"
			:style="{ width: `${width}px`, height: `${height}px` }"
		>
			<slot />
		</div>
	</div>
</template>
<script setup lang="ts">
import { ref } from 'vue'
import { domToBlob } from 'modern-screenshot'

const props = defineProps<{
	backgroundColor?: string
	width: number
	height: number
}>()

const renderContext = ref<HTMLElement>()

const renderAsImage = async (): Promise<Blob | undefined> => {
	if (!renderContext.value) {
		return
	}

	const blob = await domToBlob(renderContext.value, {
		backgroundColor: props.backgroundColor,
		width: props.width,
		height: props.height,
		scale: 2
	})

	if (!blob) {
		return
	}

	return blob
}

defineExpose({
	renderAsImage
})
</script>
